import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Role } from '../models/approval-flow-definition.model';
import { ApprovalService } from './approval.service';
import { AuthService } from '../../../../services/auth.service';
import { environment } from '../../../../services/global-environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private apiUrl = `${environment.apiUrl}/api/roles`;

  constructor(
    private http: HttpClient,
    private approvalService: ApprovalService,
    private authService: AuthService
  ) { }

  getAllRoles(): Observable<Role[]> {
    console.log('取得角色資料從 AuthService');

    // 從 AuthService 取得角色選項
    const roleOptions = this.authService.roleOptions;

    // 將 RoleOption 轉換為 Role 格式
    const roles: Role[] = roleOptions.map(option => ({
      id: option.value,
      name: option.label,
      departmentId: null, // 角色不綁定特定部門
      isCommonRole: true  // 標記為通用角色
    }));

    console.log('轉換後的角色資料:', roles);
    return of(roles);
  }
}
